// App.js
import React, { useState, useEffect } from 'react';
import { API_URL, ENDPOINTS } from '../../constants/api';
import ObjectTabs from './components/ObjectTabs';
import SqlSidebar from './components/SqlSidebar';
import { getToken } from '../../utils/TokenUtils';
import axios from 'axios';
import './css/SqlHome.css';
import SqlEditor from './components/Editor';

const SqlHome = () => {
  const [dbObjects, setDbObjects] = useState({});
  const [selectedType, setSelectedType] = useState('Table');
  const [selectedObject, setSelectedObject] = useState(null);
  const token = getToken();

  useEffect(() => {
    const loadDbObjects = async () => {
      const response = await axios.get(
        `${API_URL}/${ENDPOINTS.SQL}/get-db-objects`,
        {
          headers: { Authorization: token ? `Bearer ${token}` : '' },
        }
      );

      setDbObjects(response.data);
    };

    loadDbObjects();
  }, []);

  // console.log('dbObjects:', dbObjects);

  return (
    <div className="" style={{ margin: 'auto', width: '95%' }}>
      <div className="row">
        <div className="col-2">
          {dbObjects && dbObjects.length > 0 && (
            <SqlSidebar
              dbObjects={dbObjects}
              selectedType={selectedType}
              setSelectedType={setSelectedType}
              setSelectedObject={setSelectedObject}
            />
          )}
        </div>
        <div className="col-10">
          <div className="main-content">
            {selectedObject ? (
              <ObjectTabs selectedObject={selectedObject} />
            ) : (
              <SqlEditor />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SqlHome;
